/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Space Invoices API
 * REST API for invoice management, customer management, and accounting operations. Features include cursor-based pagination for efficient data navigation, flexible JSON querying with MongoDB-style operators, full-text search across multiple fields, and comprehensive metadata support for custom tracking.
 * OpenAPI spec version: 1.0.0
 */

export type RenderDeliveryNotePreviewTemplate = typeof RenderDeliveryNotePreviewTemplate[keyof typeof RenderDeliveryNotePreviewTemplate];


export const RenderDeliveryNotePreviewTemplate = {
  modern: 'modern',
  classic: 'classic',
  condensed: 'condensed',
  minimal: 'minimal',
  fashion: 'fashion',
} as const;
